<template>
  <div v-if="isVisible" class="splash-screen">
    <div class="splash-content">
      <img :src="BP_LOGO" alt="Logo" class="splash-logo" />
    </div>
  </div>
</template>

<script>
import { BP_LOGO } from '../shared/global';

export default {
  name: 'SplashScreen',
  data() {
    return {
      isVisible: true,
      BP_LOGO,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isVisible = false;
      this.$emit('splash-complete');
    }, 3000);
  },
};
</script>

<style scoped>
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.5s ease-in;
}

.splash-logo {
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
  animation: pulse 2s infinite;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
